import { styled } from "@mui/material";

export const OwnersAndUsers = styled("div")({});

export const Info = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 12,
});
